<template>
	<section class="content">
		<div class="flex justify-content-center">
			<div class="w-100 card">
				<div class="card-body">
					<div class="row">
						<div class="col-12 col-sm-6 col-md-4">
							<div class="info-box">
								<span class="info-box-icon bg-info elevation-1">
									<i class="fas fa-bookmark"></i>
								</span>
								<div class="info-box-content">
									<h5 class="info-box-text">TOTAL TICKETS</h5>
									<h5 class="info-box-number">{{ allTicket.total }}</h5>
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-6 col-md-4">
							<div class="info-box">
								<span class="info-box-icon bg-warning elevation-1">
									<i class="fas fa-inbox"></i>
								</span>
								<div class="info-box-content">
									<h5 class="info-box-text">PENDING TICKETS</h5>
									<h5 class="info-box-number">{{ allTicket.pending }}</h5>
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-6 col-md-4">
							<div class="info-box">
								<span class="info-box-icon bg-success elevation-1">
									<i class="fas fa-check-double"></i>
								</span>
								<div class="info-box-content">
									<h5 class="info-box-text">CLOSED TICKETS</h5>
									<h5 class="info-box-number">{{ allTicket.closed }}</h5>
								</div>
							</div>
						</div>
					</div>
					<div class="row form-horizontal mb-3">
						<div class="col-auto">
							<label class="control-label my-2 ml-2">
								<h6>Filter Pencarian</h6>
							</label>
						</div>
						<div class="col col-sm-auto">
							<select class="form-control" @change="dataType($event)">
								<option value="createdOn">Dibuat Antara</option>
								<option value="lastTm">Update Antara</option>
							</select>
						</div>
						<div class="col-12 col-sm-auto">
							<div class="input-group mb-3">
								<input type="text" ref="daterange" class="form-control" style="border-right: 0" />
								<div class="input-group-append">
									<div class="input-group-text" style="background-color: #fff">
										<span><span class="fa fa-calendar"></span></span>
									</div>
								</div>
							</div>
						</div>
						<div class="col col-sm-auto">
							<select class="form-control" @change="ticketType($event)" id="filterStatus">
								<option value="" disabled selected>Status</option>
								<option value="open" id="open">Open</option>
								<option value="closed" id="closed">Closed</option>
								<option value="pending" id="pending">Pending</option>
							</select>
						</div>
						<div class="col-auto ml-auto">
							<div class="btn-group mr-3" ref="toolbar">
								<button type="button" data-action="read" class="btn btn-outline-primary"><i
										class="fa fa-sync-alt"></i></button>
								<button type="button" :disabled="downloading" v-on:click="downloadXlsx"
									data-action="export-xlsx" class="btn btn-outline-primary"><i class="fa fa-download"></i> <span class="d-none d-md-inline-block">Download</span></button>
							</div>
							<button class="btn btn-primary" data-toggle="modal" data-target="#createTicketBatch" data-backdrop="static" data-keyboard="false">
								<i class="fi fi-rr-plus"></i> Buat Tiket Batch
							</button>
						</div>
					</div>
					<div class="table-ticket">
						<table class="table table-hover" ref="tblticket" id="tblticket">
							<thead>
								<tr>
									<th>AWB</th>
									<th>JUDUL</th>
									<th>PIC</th>
									<th>CS</th>
									<th>PRIORITAS</th>
									<th>STATUS</th>
									<th>STATUS KIRIMAN</th>
									<th>DIBUAT</th>
									<th>UPDATE</th>
									<th>UMUR</th>
									<th>KOMENTAR</th>
									<th>TINDAKAN</th>
								</tr>
							</thead>
							<tbody @click="handleClick"></tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="createTicketBatch" tabindex="-1" role="dialog" aria-labelledby="createTicketBatchLabel">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header bg-light">
						<h5 class="modal-title font-weight-bold" id="createTicketBatchLabel">Buat Tiket Batch</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body bg-white">
						<form ref="dzone" class="dropzone card bg-light cursor-pointer m-3" style="border-style: dashed;">
							<div class="overlay" v-if="loading">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
							<div class="dz-message text-muted m-0" data-dz-message>
								<h4>
									<div class="mb-3">
										<img :src="require('../assets/img/document.svg')" style="width: 10%;" />
									</div>
									<h6 class="font-weight-bold mb-0">Upload Template Tiket Batch</h6>
									<small class="text-sm">{{file_name == null ? 'Drag & Drop, or Browse Files' : file_name}}</small>
								</h4>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button class="btn btn-outline-maroon mr-auto" @click="downloadTemplate" @disabled="downloading" style="">Unduh Template</button>
						<button class="btn btn-outline-maroon d-none" @click="chooseTemplate">Upload Template</button>
						<button type="reset" class="btn btn-outline-primary" data-dismiss="modal">Batal</button>
						<button type="submit" class="btn btn-primary" data-dismiss="modal" :disabled="disableSubmit" @click="uploadTemplate">Lanjutkan</button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import { createTable, authFetch, auth } from "@/libs/hxcore";
import Swal from "sweetalert2";
import $ from "jquery";
import 'jquery-ui';
import Daterangepicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";
import moment from "moment";
import XLSX from "xlsx";
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";

export default {
	name: "Ticket",
	data() {
		return {
			dateStart: moment().add(-3, 'days').format("YYYY-MM-DD"),
			dateEnd: moment().format("YYYY-MM-DD"),
			method: "",
			roles: "",
			allTicket: {},
			downloading: false,
			show: false,
			filter: {},
			form: {
				status: "",
			},
			dt1: moment().add(-3, 'days'),
			dt2: moment(),
			data_type: "createdOn",
			ticket_type: "",
			loading: false,
			data_excel: [],
			file_name: null,
			hiddenFileInput: null
		};
	},
	watch:{
		$route (to, from){
			if (to.path === "/settings/tickets/all") {
				// sessionStorage.filterData = '';
				// sessionStorage.filterStatus = '';
				// this.filter = {};
				sessionStorage.clear();
				this.table.api().ajax.reload();
				this.loadAllStatus();
			}
		}
	},
	created: function () {
		// console.log("filter: ",this.$route.params);
		this.roles = this.$route.meta.roles;
		this.userInfo = auth.user();
		if(this.$route.params.filter) {
			this.filter = this.$route.params.filter;
			this.loadAllStatus(this.filter);
		} else {
			this.filter.dt1 = this.dt1.format('YYYY-MM-DD');
			this.filter.dt2 = this.dt2.format('YYYY-MM-DD');
			this.loadAllStatus(this.filter);
		}

		if (this.filter.dt1 && this.filter.dt2) {
			this.dt1 = moment(this.filter.dt1);
			this.dt2 = moment(this.filter.dt2);
		} else {
			this.filter.dt1 = this.dt1.format('YYYY-MM-DD');
			this.filter.dt2 = this.dt2.format('YYYY-MM-DD');
		}

		this.dateStart = this.dt1.format('YYYY-MM-DD');
		this.dateEnd = this.dt2.format('YYYY-MM-DD');
		if (this.filter.gid) {
			this.groupId = this.filter.gid;
			this.dateStart = '';
			this.dateEnd = '';
		}

		if (Object.keys(this.filter).length < 1 && sessionStorage.filterData) {
			this.filter = JSON.parse(sessionStorage.filterData);
		} else {
			sessionStorage.filterData = JSON.stringify(this.filter);
			sessionStorage.filterStatus = 1;
		}

		this.filter.datatype = this.data_type;
		if (this.filter.open > 0) {
			this.filter.ticket = 'open';
		} else if (this.filter.closed > 0) {
			this.filter.ticket = 'closed';
		} else {
			this.ticket_type = '';
		}

		// this.filter.ticket = this.filter.open > 0 ? this.ticket_type == "open" : this.ticket_type == "closed";
	},
	methods: {
		onDate() {
			this.table.api().ajax.reload();
		},
		dataType(event) {
			this.data_type = event.target.value;
			this.filter.datatype = this.data_type;
			// this.table.api().ajax.reload();
		},
		ticketType(event) {
			sessionStorage.clear();
			let self = this;
			self.filter = {};
			self.ticket_type = event.target.value;
			self.filter.ticket = self.ticket_type;
			self.filter.dt1 = self.dateStart;
			self.filter.dt2 = self.dateEnd;
			self.filter.datatype = self.data_type;
			// console.log(self.filter.ticket);
			self.onDate();
			self.loadAllStatus(self.filter.ticket);
			// self.table.api().ajax.reload();
		},
		loadAllStatus(params) {
			// console.log("params ", Object.keys(params));
			var data = '';
			if (!params) {
				data = '';
			} else if (params == 'open' || params == 'closed' || params == 'pending') {
				var ticket = { ticket: params, dt1: this.dateStart, dt2: this.dateEnd };
				data = new URLSearchParams(ticket);
			} else {
				data = Object.keys(params)
					.map(
						(key) =>
							encodeURIComponent(key) + "=" + ((params[key] ===false || params[key] === undefined)?0 : encodeURIComponent(params[key]))
					)
					.join("&");
			}
			// console.log(data);

			let url = '';
			// let url = '';
			if (params) {
				url = "/ticket/history/all_tickets?" + data;
			} else {
				url = "/ticket/history/all_tickets";
			}

			authFetch(url)
				.then((res) => {
					if (res.status === 201) {
					} else if (res.status === 400) {
					}
					return res.json();
				})
				.then((js) => {
					this.allTicket = js.data;
				});
		},
		downloadXlsx: function (e) {
			this.downloading = true;
			var filter = JSON.parse(JSON.stringify(this.filter));
				filter.q = $("input[name=q]").val();
				filter.category = $("select[name=category]").val();
			// console.log(filter)
			var data = Object.keys(filter)
				.map(
					(key) =>
					encodeURIComponent(key) + "=" + (filter[key] === false ? 0 : encodeURIComponent(filter[key]))
				)
				.join("&");
			// console.log(data)
			authFetch("/ticket/history/download", {
					method: "POST",
					body: data,
				})
				.then((response) => response.blob())
				.then((blob) => {
					setTimeout(() => {
						this.downloading = false;
					}, 1000);
					var url = window.URL.createObjectURL(blob);
					var a = document.createElement("a");
					a.href = url;
					a.download = "data.xlsx";
					document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
					a.click();
					a.remove(); //afterwards we remove the element again
				});
		},
		infoClaim(claim) {
			var statusClaim = '';
			if (claim == 1)
				statusClaim = '<span class="badge badge-danger">Paket Diclaim</span>';
			else if (claim == 2)
				statusClaim = '<span class="badge badge-success">Claim disetujui</span>';
			else if (claim == 3)
				statusClaim = '<span class="badge badge-danger">Claim ditolak</span>';
			return statusClaim;
		},
		infoStatus(track) {
			var output = '';
			if (track.cancel == 1) {
				output += '<span class="badge badge-danger">Cancel</span>';
			} else if (track.pickupStatus == 0) {
				output += '<span class="badge badge-inverse">DRAFT</span>';
			} else {
				if (track.trackingStatus == 0) {
					if (parseInt(track.order_type) == 1) {
						output += '<span class="badge badge-secondary">Menunggu Drop</span>';
					} else {
						output += '<span class="badge badge-secondary">Menunggu Pickup</span>';
					}
					output += this.infoClaim(track.retClaim);
				} else if (track.trackingStatus == 1) {
					output += '<span class="badge badge-warning">Proses</span>';
					output += this.infoClaim(track.retClaim);
				} else if (track.trackingStatus == 2) {
					output += '<span class="badge badge-success">Terkirim</span>';
					output += this.infoClaim(track.retClaim);
				} else if (track.trackingStatus == 3) {
					output += '<span class="badge badge-warning">Proses Retur</span>';
					output += this.infoClaim(track.retClaim);
				} else if (track.trackingStatus == 4) {
					if (track.retStatus == 1) {
						output += '<span class="badge badge-success">Retur Diterima</span>';
						output += this.infoClaim(track.retClaim);
					} else if (!track.retStatus) {
						output += '<span class="badge badge-info">Retur Diserahkan</span>';
						output += this.infoClaim(track.retClaim);
					}
				} else if (track.trackingStatus == 5) {
					if (track.problem_description != null) {
						output += ' <span class="badge badge-danger">Paket Bermasalah - '+track.problem_description+'</span>';
					} else {
						output += ' <span class="badge badge-danger">Paket Bermasalah</span>';
					}
					output += this.infoClaim(track.retClaim);
				}
			}
			/*
			var output = '';
			output += this.statusTracking;
			output += this.statusClaim;
			*/
			return output;
		},
		handleClick(e) {
			if (e.target.matches(".link-order")) {
					let route = this.$router.resolve({
								path: "/order/detail/" + e.target.dataset.id
						});
						window.open(route.href,"_blank");
				// return false;
			} if (e.target.closest('.btn-comment')) {
				//this.isShowTicket = !this.isShowTicket;
				var el = e.target.closest('.btn-comment');
				// console.log(el)
				this.$root.$emit("openTicketComment", el.dataset.id);
				return false;
			} if (e.target.matches("button")) {
				if (e.target.dataset.action == "change") {
					this.form.status = e.target.dataset.status;
					Swal.fire({
						title: e.target.dataset.status == 3 ? "Pending?" : e.target.dataset.status == 2 ? "Closed?" : "Open?",
						showCancelButton: true,
						confirmButtonText: `Ya`,
						cancelButtonText: "Tidak",
					}).then((result) => {
						/* Read more about isConfirmed, isDenied below */
						if (result.isConfirmed) {
							var data = Object.keys(this.form)
								.map(
									(key) => encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key])
								)
								.join("&");

							authFetch("/ticket/history/" + e.target.dataset.id, {
								method: "PUT",
								body: data,
							}).then((res) => {
								return res.json();
							}).then((js) => {
								if (js.success) {
									Swal.fire("Proses Berhasil", ``, "success");
									this.table.api().ajax.reload();
									this.loadAllStatus();
								} else {
									Swal.fire("Proses gagal", ``, "error");
									this.table.api().ajax.reload();
								}
							});
						}
					});
				}
				// console.log(e.target);
				return false;
			}
		},
		downloadTemplate() {
			this.downloading = true;
			authFetch("/file/aset/template_tiket", {
				method: "GET",
			})
				.then((response) => response.blob())
				.then((blob) => {
					this.downloading = false;
					var url = window.URL.createObjectURL(blob);
					var a = document.createElement("a");
					a.href = url;
					a.download = "template_tiket.xlsx";
					document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
					a.click();
					a.remove(); //afterwards we remove the element again
				});
		},
		chooseTemplate() {
			this.hiddenFileInput.click();
		},
		uploadTemplate: function (ev) {
			var tickets = this.excelImport(this.data_excel);

			if (tickets.length == 0) {
				this.customSwal.fire({
					title: 'Proses gagal',
					html: 'Data atau kolom tidak sesuai!',
					showConfirmButton: false,
					showCancelButton: true,
					cancelButtonText: 'Kembali',
				});
			} else {
				this.$router.push({ name: "Tiket Batch", params: { tickets: tickets } });
			}
		},
		excelImport(data) {
			var data_upload = [];

			for (var i = 0; i < data.length; i++) {
				if (!data[i]['No. AWB'] || !data[i]['Kategori'] || !data[i]['Ticket Comment']) {
					data_upload = [];
					break;
				} else {
					var aData = {
						id: null,
						refcode: data[i]['No. AWB'],
						title: data[i]['Kategori'],
						category: null,
						priority: 1,
						message: data[i]['Ticket Comment'],
						attachments: null,
					};
					data_upload.push(aData);
				}
			}

			return data_upload;
		}
	},
	computed: {
		disableSubmit: function() {
			return (!this.file_name || this.loading);
		}
	},
	mounted() {
		this.$gtag.event(`page_view`, {
			'event_name': 'List Tiket'
		});
		const e = this.$refs;
		const self = this;
		this.$root.$on('reloadDashboardTicket', () => {
			this.loadAllStatus();
			this.table.api().ajax.reload( null, false ); // user paging is not reset on reload
		})

		if (this.$route.params?.filter?.closed) {
			$("#closed").prop("selected", true);
		} else if (this.$route?.params?.filter?.open) {
			$("#open").prop("selected", true);
		} else if (this.$route.params?.filter?.pending) {
			$("#pending").prop("selected", true);
		}

		new Daterangepicker(
			this.$refs.daterange,
			{
				startDate: !this.dt1 ? moment().day(-31) : this.dt1,
				endDate: !this.dt2 ? moment() : this.dt2,
			},
			function (d1, d2) {
				self.dateStart = d1.format("YYYY-MM-DD");
				self.dateEnd = d2.format("YYYY-MM-DD");
				self.data_type = self.data_type;
				self.filter.datatype = self.data_type;
				// self.filter.ticket = self.ticket_type;
				self.filter.dt1 = self.dateStart;
				self.filter.dt2 = self.dateEnd;
				self.onDate();
				var json = { dt1: self.filter.dt1, dt2: self.filter.dt2, ticket: self.filter.ticket };
				self.loadAllStatus(json);
			}
		);
		var isAdmin = this.userInfo.role_id < 6;
		var isShipper = this.userInfo.role_id > 10;
		var isKurir = this.userInfo.role_id == 9;
		this.table = createTable(e.tblticket, {
			title: "List Ticket",
			roles: this.$route.params.roles,
			ajax: "/ticket/history",
			frame: false,
			scrollX: true,
			autoWidth:false,
			deferRender : true,
			processing: true,
			language: {
				processing: '<i class="fa fa-spinner fa-spin" style="font-size:50px;color:black;"></i>'},
			selectedRowClass: "",
			toolbarEl: e.toolbar,
			lengthChange: true,
			filter: true,
			filterBy: [0, 1, 2],
			stateSave: true,
			paramData: function (d) {
				var filter = JSON.parse(JSON.stringify(self.filter));
				for (const key in filter) {
					d[key] = filter[key] === false ? 0: filter[key];
				}
			},
			// "order": [[ 7, 'asc' ]],
			columns: [
				{
					data: "no_resi",
					render: function (data, type, row, meta) {
						return `<span class="link link-order text-info" style="cursor:pointer;" data-id="${row.order_no}">${row.no_resi}</span>`;
					},
				},
				{ data: "title" },
				{ data: "sender_name" },
				{
					data: "usercs",
					visible: isAdmin ? true : false,
				},
				{
					data: "priorityName",
					render: function (data, type, row, meta) {
						var cls = 'secondary';
						if(data=='High')cls='danger';
						else if(data=='Urgent')cls='warning';
						return (
							"<span class='badge badge-"+cls+"'>" + row.priorityName + "</span>"
						);
					},
				},
				{
					data: "status",
					render: function (data, type, row, meta) {
						if (row.status == 0) return "";
						else if (row.status == 1)
							return '<span class="badge badge-info">Open</span>';
						else if (row.status == 2)
							return '<span class="badge badge-success">Closed</span>';
						else if (row.status == 3)
							return '<span class="badge badge-warning">Pending</span>';
						else return "";
					},
				},
				{
					data: "pickupStatus",
					visible: isAdmin ? true : false,
					render: function (data, type, row, meta) {
						var badge = '';
						badge = self.infoStatus(row);
						 /*
						if (row.cancel == 1)
							badge = '<span class="badge badge-danger">Cancel</span>';
						else if (row.pickupStatus == 0)
							badge = '<span class="badge badge-inverse">DRAFT</span>';
						else {
							if (row.trackingStatus == 0)
								badge = '<span class="badge badge-secondary">Menunggu Pickup</span>';
							else if (row.trackingStatus == 1)
								badge = '<span class="badge badge-warning">Proses</span>';
							else if (row.trackingStatus == 2)
								badge = '<span class="badge badge-success">Terkirim</span>';
							else if (row.trackingStatus == 3)
								badge = '<span class="badge badge-warning">Proses Retur</span>';
							else if (row.trackingStatus == 4) {
								if (row.retStatus == 1)
									badge = '<span class="badge badge-success">Retur Diterima</span>';
								else if (!row.retStatus && !row.retClaim)
									badge = '<span class="badge badge-info">Retur Diserahkan</span>';
								else if (row.retClaim == 1)
									badge = '<span class="badge badge-danger">Paket Diclaim</span>';
								else if (row.retClaim == 2)
									badge = '<span class="badge badge-success">Retur Claim disetujui</span>';
								else if (row.retClaim == 3)
									badge = '<span class="badge badge-danger">Retur Claim ditolak</span>';
							} else if (row.trackingStatus == 5) {
								badge = '<span class="badge badge-danger">Bermasalah</span>';
								if (row.retClaim == 1)
									badge = badge + ' <span class="badge badge-danger">Paket Diclaim</span>';
								else if (row.retClaim == 2)
									badge = badge + ' <span class="badge badge-success">Retur Claim disetujui</span>';
								else if (row.retClaim == 3)
									badge = badge + ' <span class="badge badge-danger">Retur Claim ditolak</span>';
								if (row.retClaim != 0)
									badge = badge + ' <span class="badge badge-info">' + row.retNote + '</span>';
							}
						} if (row.updated == 1) badge += ' <span class="badge badge-warning"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Updated</span>';
						*/
						return badge;
					},
				},
				{ data: "created_on" },
				{ data: "lastUpdate" },
				{ data: "aging", render: function (data, type, row, meta) { return data + ' Hari' } },
				{ data: "totalComment", class:'text-center', render: function (data, type, row, meta) {
					var clsTxt = '';
					var clsIcn = 'far fa-comment';
					let tooltipTxt = row.replied ? 'Sudah dibaca, Belum terjawab' : 'Sudah dibaca, Sudah terjawab';

					if (row.totalComment>1) {
						clsIcn = 'far fa-comments';
						if (row.replied) {
							tooltipTxt = 'Sudah dibaca, Belum terjawab';
						}
					} if (row.newUpdate && row.me_last!=1) {
						tooltipTxt = row.status == 2 ? 'Belum dibaca, Tidak terjawab' : 'Belum dibaca, Belum terjawab';
						clsTxt='text-primary';
						clsIcn = 'fa fa-comment';
						if (row.totalComment>1) clsIcn = 'fa fa-comments';
					} if (row.newUpdate) {}
					var replied = !row.replied?'':' <i class="fa fa-question"></i> ';
					return ('<div class="btn-comment" style="cursor:pointer;" data-id="'+row.ref_code+'" data-toggle="tooltip" data-html="true" title="<h6><strong>'+tooltipTxt+'</strong></h6>"><span class="'+clsTxt+'"><i class="'+clsIcn+'"></i></span> '+data+replied+'</div>');
				} },
				{
					data: "ref_code",
					sortable:false,
					// visible: isShipper ? false : true,
					render: function (data, type, row, meta) {
						if (row.status == 1) {
							return (
								`<div class="btn-group btn-sm">
									<button type="button" class="btn border-dark shadow-sm dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										Ubah Status
									</button>
									<div class="dropdown-menu dropdown-menu-right">
										<button type="button" class="btn btn-sm btn-warning dropdown-item" data-action="change" data-status="3" data-id="` +
											row.id +
											`">Pending</button>
										<button type="button" class="btn btn-sm btn-info dropdown-item" data-action="change" data-status="2" data-id="` +
											row.id +
											`">Closed</button>
									</div>
								</div>`
							);
						} else if (row.status == 2) {
							return (`<button type="button" class="btn btn-sm btn-success shadow-sm dropdown-item" data-action="change" data-status="1" data-id="` +
								row.id +
								`">Re-Open</button>`);
						} else if (row.status == 3) {
							return (
								`<div class="btn-group btn-sm">
									<button type="button" class="btn border-dark shadow-sm dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										Ubah Status
									</button>
									<div class="dropdown-menu dropdown-menu-right">
										<button type="button" class="btn btn-sm btn-success dropdown-item" data-action="change" data-status="1" data-id="` +
											row.id +
											`">Open</button>
										<button type="button" class="btn btn-sm btn-info dropdown-item" data-action="change" data-status="2" data-id="` +
											row.id +
											`">Closed</button>
									</div>
								</div>`
							);
						} else {
							return "-";
						}
					},
				},
			],
			rowCallback: function (row, data) {},
			drawCallback: function () {
					$(document).ready(function(){
						$('[data-toggle="tooltip"]').tooltip();
				});
			},
			initComplete: function () {
				$('.loading-overlay').removeClass('show');
			}
		});

		Dropzone.autoDiscover = false;

		let myDropzone = new Dropzone(this.$refs.dzone, {
			uploadMultiple: false,
			maxFiles: 1,
			createImageThumbnails: false,
			autoProcessQueue: false,
			url: 'getMeSomeUrl',
			accept: function(file, done) {
				this.removeFile(file);
			},
			success: function(file){
				this.removeFile(file);
			}
		});

		myDropzone.on("addedfile", file => {
			const reader = new FileReader();
			this.loading = true;
			// this.disableSubmit;
			reader.onload = () => {
				var fileData = reader.result;
				var wb = XLSX.read(fileData, { type: "binary" });
				var worksheet = wb.Sheets[wb.SheetNames[0]];

				/*
				if (this.form.order_online == 0){
					 var range = XLSX.utils.decode_range(worksheet['!ref']);
					 range.s.r = 1; // <-- zero-indexed, so setting to 1 will skip row 0
					 worksheet['!ref'] = XLSX.utils.encode_range(range);
				}
				*/

				var rowObj = XLSX.utils.sheet_to_json(worksheet);
				this.data_excel = rowObj;

				this.file_name = file.name;
				this.loading = false;
				// this.disableSubmit;
			};
			reader.onabort = () => console.log('file reading was aborted');
			reader.onerror = () => console.log('file reading has failed');
			reader.readAsBinaryString(file);
		});

		myDropzone.on("maxfilesexceeded", function (file) {
			myDropzone.removeAllFiles();
		});

		this.hiddenFileInput = myDropzone.hiddenFileInput;

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});
	}
};
</script>
<style>
.table-ticket .dataTables_scrollBody{min-height: 100px}
</style>